var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 5.67864V8.03388M3.8 9.50591V12.0083C3.8 12.1451 3.8 12.2134 3.80578 12.271C3.86189 12.8301 4.31265 13.2724 4.88238 13.3275C4.94105 13.3332 5.0107 13.3332 5.15 13.3332C5.2893 13.3332 5.35895 13.3332 5.41762 13.3275C5.98735 13.2724 6.43811 12.8301 6.49422 12.271C6.5 12.2134 6.5 12.1451 6.5 12.0083V9.50591M3.8 9.50591C3.24087 9.50591 2.96131 9.50591 2.74078 9.41626C2.44675 9.29674 2.21314 9.06749 2.09135 8.77894C2 8.56253 2 8.28818 2 7.73948L2 7.03291C2 6.04361 2 5.54896 2.19619 5.1711C2.36876 4.83873 2.64412 4.5685 2.98282 4.39915C3.36786 4.20662 3.8719 4.20662 4.88 4.20662H6.5M3.8 9.50591H6.5M6.5 9.50591H6.95C8.00986 9.50591 9.30635 10.0634 10.3066 10.5985C10.8901 10.9107 11.1819 11.0668 11.3729 11.0438C11.5501 11.0225 11.6841 10.9444 11.788 10.8019C11.9 10.6483 11.9 10.3408 11.9 9.72595V3.98657C11.9 3.37168 11.9 3.06424 11.788 2.91058C11.6841 2.76809 11.5501 2.69002 11.3729 2.66872C11.1819 2.64575 10.8901 2.80183 10.3066 3.11399C9.30635 3.64908 8.00985 4.20662 6.95 4.20662H6.5M6.5 9.50591V4.20662",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.18cdfd85008232a4fd572d3af85c6f55.svg";
export { ForwardRef as ReactComponent };